export abstract class Serializable {
  serialize(): any {
    //return Object.assign({}, this);
    return {};
  }

  abstract deserialize(input: any);
}
